/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadServiceCreateUploadFileResponse
 */
export interface UploadServiceCreateUploadFileResponse {
    /**
     * 
     * @type {string}
     * @memberof UploadServiceCreateUploadFileResponse
     */
    uploadId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadServiceCreateUploadFileResponse
     */
    fileId?: string | null;
}

/**
 * Check if a given object implements the UploadServiceCreateUploadFileResponse interface.
 */
export function instanceOfUploadServiceCreateUploadFileResponse(value: object): value is UploadServiceCreateUploadFileResponse {
    return true;
}

export function UploadServiceCreateUploadFileResponseFromJSON(json: any): UploadServiceCreateUploadFileResponse {
    return UploadServiceCreateUploadFileResponseFromJSONTyped(json, false);
}

export function UploadServiceCreateUploadFileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadServiceCreateUploadFileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'uploadId': json['uploadId'] == null ? undefined : json['uploadId'],
        'fileId': json['fileId'] == null ? undefined : json['fileId'],
    };
}

export function UploadServiceCreateUploadFileResponseToJSON(json: any): UploadServiceCreateUploadFileResponse {
    return UploadServiceCreateUploadFileResponseToJSONTyped(json, false);
}

export function UploadServiceCreateUploadFileResponseToJSONTyped(value?: UploadServiceCreateUploadFileResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uploadId': value['uploadId'],
        'fileId': value['fileId'],
    };
}

